<app-btn-group-nav [pages]="pages"
                   [identifier]="'location'"
                   (activePageChange)="activePage = $event"/>

<div class="mt-4">
  @if (model()) {
    <router-outlet></router-outlet>
  }
  @if (!model()) {
    <app-spinner></app-spinner>
  }
</div>
